<div class="user-tasks-content" *ngIf="generalUserAssignmentsData && generalUserAssignmentsData?.length > 0">
  <div class="tasks-header-general">
    <svg-icon src='./assets/icons/Project_icon.svg'
              class="raci-icon svg-icon-black icon-general-header" title="{{'raci.raciStepsPane.generalTitle' | translate}}"></svg-icon>
    <p [ngClass]="activeTaskAssignment ? 'selected-item' : ''">{{'raci.raciStepsPane.generalTitle' | translate}}</p>
  </div>

  <div class="task-content-body-general" *ngFor="let generalAssignment of generalUserAssignmentsData">
    <div class="tasks-header"
         (click)="toggle(generalAssignment)">
      <div class="header-info">
        <div class="raci-icon parent-item-icon-white icon-bg-black" title="{{'raci.raciStepsPane.generalTitle' | translate}}">
          <p class="user-dashboard-crm-icon">CRM</p>
        </div>
        <p [ngClass]="hasSelectedTask(generalAssignment) ? 'selected-item' : ''">{{generalAssignment?.name}} &nbsp; </p>
      </div>
      <div *ngIf="generalAssignment.generalTasks.length > 0" class="toogle">
        <svg-icon src='./assets/icons/chevron-down-outline.svg'
                  class="raci-icon icon-toogle"
                  [ngClass]="generalAssignment?.showContent ? 'icon-toogle-rotate' : '' "
                  title="{{'raci.raciStepsPane.valuationPortfolio' | translate}}">
        </svg-icon>
      </div>
    </div>

    <div class="children-body-general" *ngIf="generalAssignment?.showContent && generalAssignment.generalTasks.length > 0">
      <div class="tasks-content-general">
        <div class="tasks" *ngFor="let generalTask of generalAssignment.generalTasks">
          <div class="task overflow-hidden" (click)="onGeneralTaskClick(generalTask)">
            <div class="task-info">
              <div class="header-info" *ngIf="!generalTask?.isCompleted && !generalTask?.dateRejected">
                <div class="raci-icon parent-item-icon-white icon-bg-black" title="{{'raci.raciStepsPane.generalTitle' | translate}}">
                  <p class="user-dashboard-crm-icon">CRM</p>
                </div>
              </div>
              <svg-icon *ngIf="generalTask?.isCompleted"
                        src='./assets/icons/checkmark.svg'
                        alt="Approved"
                        title="{{'projectToolbar.approved' | translate}}"
                        class="raci-icon raci-step-icon-done"
                        align='center'>
              </svg-icon>
              <svg-icon *ngIf="!generalTask?.isCompleted && generalTask?.dateRejected"
                        src='./assets/icons/close-outline.svg'
                        alt="Rejected"
                        title="{{'projectToolbar.rejected' | translate}}"
                        class="raci-icon-bg-red raci-icon parent-item-icon-white icon-bg-black"
                        align='center'>
              </svg-icon>
            </div>
            <h4 class="text" title="{{generalTask?.name}} &nbsp; | &nbsp; {{generalTask?.projectRequestDate | date: 'dd.MM.YYYY' }}" [ngClass]="activeTaskId == generalTask.oid ? 'selected-item' : ''">
              {{generalTask?.name}} &nbsp; | &nbsp; {{generalTask?.projectRequestDate | date: 'dd.MM.YYYY' }}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="user-tasks-content">
  <div class="task-content-body" *ngFor="let item of filteredData">
    <div class="tasks-header"
         (click)="toggle(item?.project)">
      <div class="header-info overflow-hidden">
        <svg-icon src='./assets/icons/Val_Portfolios_icon.svg'
                  class="raci-icon raci-icon-small parent-item-icon-white icon-bg-red" title="{{'raci.raciStepsPane.valuationPortfolio' | translate}}"></svg-icon>
        <p class="text" title="{{item.project?.projectName}}" [ngClass]="activeProjectId == item.project.projectId ? 'selected-item' : ''">{{item.project?.projectName}} &nbsp; </p>
      </div>
      <div class="toogle">
        <svg-icon src='./assets/icons/chevron-down-outline.svg'
                  class="raci-icon icon-toogle"
                  [ngClass]="item.project?.showContent ? 'icon-toogle-rotate' : '' "
                  title="{{'raci.raciStepsPane.valuationPortfolio' | translate}}">
        </svg-icon>

      </div>
    </div>
    <div class="children-body" *ngIf="item.project?.showContent">
      <div class="project-content" *ngFor="let valuationEvent of item.valuationEvents">
        <div class="tasks-header"
             (click)="toggle(valuationEvent?.valEvent, valuationEvent)">
          <div class="header-info overflow-hidden">
            <svg-icon src='./assets/icons/Val_Portfolios_icon.svg'
                      class="raci-icon raci-icon-small parent-item-icon-white icon-bg-red" title="{{'raci.raciStepsPane.valuationPortfolio' | translate}}"></svg-icon>
            <p class="text" title="{{valuationEvent.valEvent?.name}} &nbsp; | &nbsp; {{valuationEvent.valEvent?.date | date: 'dd.MM.YYYY'}}" [ngClass]="activeValEventId == valuationEvent.valEvent.oid ? 'selected-item' : ''" title="{{valuationEvent.valEvent?.name}} &nbsp; | &nbsp; {{valuationEvent.valEvent?.date | date: 'dd.MM.YYYY'}}">
              {{valuationEvent.valEvent?.name}} &nbsp; | &nbsp; {{valuationEvent.valEvent?.date | date: "dd.MM.YYYY"}}
            </p>
          </div>
          <div class="toogle">
            <svg-icon src='./assets/icons/chevron-down-outline.svg'
                      class="raci-icon icon-toogle"
                      [ngClass]="valuationEvent.valEvent?.showContent ? 'icon-toogle-rotate' : '' "
                      title="{{'raci.raciStepsPane.valuationPortfolio' | translate}}">
            </svg-icon>
          </div>
        </div>
        <div class="tasks-content" *ngIf="valuationEvent.valEvent?.showContent">
          <div class="tasks" *ngFor="let task of valuationEvent?.tasks">
            <div class="task overflow-hidden" (click)="!task?.taskInfo?.isGeneralTask ? onTaskClick(task, valuationEvent, item) : onGeneralTaskClick(task.taskInfo, item)">
              <div class="task-info">
                <div class="header-info" *ngIf="!task?.taskInfo?.isCompleted && task?.taskInfo?.isGeneralTask">
                  <div class="raci-icon parent-item-icon-white icon-bg-black" title="{{'raci.raciStepsPane.generalTitle' | translate}}">
                    <p class="user-dashboard-crm-icon">CRM</p>
                  </div>
                </div>
                <svg-icon *ngIf="!task?.taskInfo?.isCompleted && !task?.taskInfo?.isGeneralTask"
                          src='./assets/icons/users.svg'
                          class="raci-icon raci-icon-small svg-icon-in-progress"
                          align='center'
                          (click)="openDialogForCompletingFunctionTask(task)">
                </svg-icon>
                <svg-icon *ngIf="task?.taskInfo?.isCompleted"
                          src='./assets/icons/checkmark.svg'
                          class="raci-icon raci-icon-small raci-step-icon-done"
                          align='center'>
                </svg-icon>
              </div>
              <h4 class="text"
                  title="{{task?.taskInfo.stepOrderNumber}}.{{task?.taskInfo.taskOrderNumber}} | {{task?.taskInfo.taskName}}"
                  *ngIf="!task?.taskInfo?.isGeneralTask"
                  [ngClass]="activeTaskId == task.taskInfo.oid ? 'selected-item' : ''">
                {{task?.taskInfo.stepOrderNumber}}.{{task?.taskInfo.taskOrderNumber}} | {{task?.taskInfo.taskName}}
              </h4>
              <h4 class="text" title="{{task?.taskInfo?.taskName}} &nbsp; | &nbsp; {{task?.taskInfo?.projectRequestDate | date: 'dd.MM.YYYY' }}"
                  [ngClass]="activeTaskId == task.taskInfo.oid ? 'selected-item' : ''"
                  *ngIf="task?.taskInfo?.isGeneralTask">
                {{task?.taskInfo?.taskName}} &nbsp; | &nbsp; {{task?.taskInfo?.projectRequestDate | date: 'dd.MM.YYYY' }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
